import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Poste } from '@models/domains/posts';
import { FilterGenerique } from '@models/api/requests';
import { ListePoste } from '@models/api/responses';
import { PagedResultDTO } from '@models/shared';
import { TypeRecrutement } from '@models/domains/recruitment';
import { MotifLiberation } from '@models/domains/recruitment';
import { Pole } from '@models/shared';

@Injectable({
  providedIn: 'root'
})
export class ReferentielsService {
  private readonly module = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private readonly http: HttpClient) {}

  getTypeRecrutement(): Observable<TypeRecrutement[]> {
    return this.http.get<TypeRecrutement[]>(this.module + '/types-recrutements/all');
  }

  getTypeRenouvellement(): Observable<any> {
    return this.http.get<any>(this.module + '/types-renouvellements/all');
  }

  getTypeContrat(): Observable<any> {
    return this.http.get<any>(this.module + '/types-contrats/all');
  }

  getListOfPostes(pageIndex: number, pageSize: number): Observable<any> {
    const params = new HttpParams().set('page', pageIndex).set('size', pageSize);
    return this.http.get<any>(this.module + '/postes', { params });
  }

  getListOfPostesWithParams(offset: number, limit: number, filtre: FilterGenerique | null = null): Observable<PagedResultDTO<ListePoste>> {
    let url = this.module + '/postes';
    let params = new HttpParams().set('page', offset).set('size', limit);

    if (filtre?.filterGenerique) {
      params = params.set('filterGenerique', filtre.filterGenerique);
    }

    return this.http.get<PagedResultDTO<ListePoste>>(`${this.module}/postes`, { params });
  }
  getPoste(idDirection?: string | null, idService?: string | null): Observable<Poste[]> {
    let direction = idDirection && idDirection !== null ? `&direction=${idDirection}` : '';
    let service = idService && idService !== null ? `&service=${idService}` : '';
    return this.http.get<Poste[]>(this.module + `/postes/all?${direction}${service}`);
  }

  getAllPostesOpened(idDirection?: string | null, idService?: string | null): Observable<Poste[]> {
    let direction = idDirection && idDirection !== null ? `&direction=${idDirection}` : '';
    let service = idService && idService !== null ? `&service=${idService}` : '';
    return this.http.get<Poste[]>(this.module + `/postes/all-opened?${direction}${service}`);
  }

  getPosteByService(idService: string): Observable<Poste[]> {
    return this.http.get<Poste[]>(this.module + `/postes/service/${idService}`);
  }

  getDetenteurPoste(idPoste: string): Observable<any> {
    return this.http.get<any>(`${this.module}/postes/${idPoste}`);
  }

  getPole(): Observable<Pole[]> {
    return this.http.get<Pole[]>(this.module + '/poles/all');
  }

  getMotifDepart(): Observable<MotifLiberation[]> {
    return this.http.get<MotifLiberation[]>(this.module + '/motifs-depart/all');
  }

  getCategoriePoste(): Observable<any> {
    return this.http.get<any>(this.module + '/categories-postes/all');
  }
}
